import styled, { css } from 'styled-components';
import { variants, th } from 'style/theme';
import { FaCaretDown, FaCheck } from 'react-icons/fa';

export const Container = styled.div`
  position: relative;
  margin-bottom: 22px;

  :last-of-type {
    margin-bottom: 0;
  }
`;

export const Value = styled.div.attrs({ className: 'single-value' })`
  bottom: 1px;
  left: 1px;

  ${(props) =>
    props.isPlaceholder &&
    css`
      font-style: italic;
      opacity: 0.5;
      font-weight: 400;
    `}

  ${variants('variant', {
    light: css`
      color: ${th('colors.white')};
    `,
    dark: css`
      color: ${th('colors.black')};
    `,
    blue: css`
      color: ${th('colors.blue')};

      ${(props) =>
        props.isPlaceholder &&
        css`
          font-style: normal;
          opacity: 1;
          font-weight: 400;
          bottom: 2px;
        `}
    `,
    block: css`
      color: ${th('colors.black')};
      font-weight: 700;
      bottom: 4px;
      left: 6px;
    `,
    'block-thick': css`
      color: ${th('colors.black')};
      font-weight: 700;
      bottom: 4px;
      left: 6px;
    `,
    global: css`
      color: ${th('colors.white')};
      opacity: 0.7;
      bottom: 4px;
      top: 4px;
      left: 8px;
      right: 8px;
    `
  })}

  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  position: absolute;

  > img {
    position: relative;
    bottom: 1.5px;
    margin-right: 6px;
  }
`;

export const CaretIcon = styled(FaCaretDown)`
  ${variants('variant', {
    light: css`
      fill: ${th('colors.white')};
    `,
    dark: css`
      fill: ${th('colors.black')};
    `,
    block: css`
      margin-right: 4px;
      fill: ${th('colors.black')};
    `,
    'block-thick': css`
      margin-right: 4px;
      fill: ${th('colors.black')};
    `,
    global: css`
      fill: ${th('colors.white')};
      margin-right: 4px;
    `,
    small: css`
      display: none;
    `,
    outline: css`
      fill: ${th('colors.turquoise')};
    `
  })}
`;

export const CheckIcon = styled(FaCheck)`
  margin-left: 7px;
  font-size: 14px;
  color: ${th('colors.bermudaGreen')};
`;

export const Error = styled.span`
  margin-left: 5px;
  color: ${th('colors.red')};
  font-weight: 700;
  font-size: 14px;
`;
